export const NAVIGATION_SET_DESKTOP = 'NAVIGATION_SET_DESKTOP';
export const NAVIGATION_SET_MOBILE = 'NAVIGATION_SET_MOBILE';
export const NAVIGATION_SET_DESKTOP_VARIATION = 'NAVIGATION_SET_DESKTOP_VARIATION';
